import React, { forwardRef } from "react";
import { Col, Row, Skeleton } from "antd";
import moment from "moment-jalaali";

const Invoice = forwardRef(function Invoice({ details }, ref) {
  if (!details)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );

  const {
    createdAt,
    user,
    paidAt,
    cancelAt,
    invoiceType,
    amountRial,
    description,
    id,
    discountAmount,
    finalAmount,
    startAt,
    effectiveStartAt,
    expectedEndAt,
  } = details;

  return (
    <div
      className="invoiceWrapper"
      style={{
        width: "100%",
        maxWidth: "148mm",
        margin: "0 auto",
        padding: "10px",
        fontFamily: "IRANSansXFaNum",
        direction: "rtl",
        boxSizing: "border-box",
      }}
    >
      <div
        className="invoice"
        style={{
          width: "100%",
          minHeight: "190mm",
          boxShadow: "0 0 10px #3a4e61",
          padding: 10,
          background: "white",
          boxSizing: "border-box",
        }}
      >
        <div
          ref={ref}
          style={{
            fontFamily: "IRANSansXFaNum", // اضافه شدن فونت به لایه‌ای که چاپ می‌شود
            direction: "rtl",
            border: "1px solid #3a4e61",
            borderRadius: 15,
            height: "100%",
            minHeight: "165mm",
            padding: 15,
            position: "relative",
            boxSizing: "border-box",
            background: "white", // اطمینان از سفید بودن پس‌زمینه کل فاکتور
          }}
        >
          {/* HEADER */}
          <div
            className="invoiceHeader"
            style={{
              display: "flex",
              flexDirection: "row-reverse",
              justifyContent: "space-between",
              alignItems: "flex-start",
              fontSize: "12px",
            }}
          >
            <div className="invoiceLogo">
              <img src={"/logo-optimized.png"} alt="صفاتک" width={100} />
            </div>

            <div
              className="invoiceInfo"
              style={{
                fontWeight: 700,
                lineHeight: "22px",
                textAlign: "right", // اضافه شدن برای اطمینان از راست‌چین بودن در چاپ
              }}
            >
              <h3
                style={{
                  paddingBottom: 10,
                  marginBottom: 10,
                  fontWeight: 800,
                  borderBottom: "1px solid #3a4e61",
                  fontSize: "16px",
                }}
              >
                فاکتور فروش خدمات
              </h3>

              <p style={{ margin: "4px 0" }}>تاریخ: {moment(createdAt).format("jYYYY/jMM/jDD")}</p>
              <p style={{ margin: "4px 0" }}>فروشنده: فضای کار اشتراکی صفاتک</p>

              <p style={{ margin: "4px 0" }}>
                خریدار:{" "}
                {user?.gender === "MALE"
                  ? "آقای "
                  : user?.gender === "FEMALE"
                    ? "خانم "
                    : ""}
                {user?.name}
              </p>

              <p style={{ margin: "4px 0" }}>
                وضعیت:
                {paidAt && !cancelAt ? (
                  <span style={{ color: "green" }}> پرداخت شده</span>
                ) : !paidAt && !cancelAt ? (
                  <span style={{ color: "orange" }}> پرداخت نشده</span>
                ) : !paidAt && cancelAt ? (
                  <span style={{ color: "red" }}> لغو شده</span>
                ) : null}
              </p>

              {paidAt && (
                <p style={{ margin: "4px 0" }}> تاریخ پرداخت: {moment(paidAt).format("jYYYY/jMM/jDD")}</p>
              )}

              {(effectiveStartAt || startAt) && (
                <>
                  <p style={{ margin: "4px 0" }}>
                    تاریخ شروع: {moment(effectiveStartAt || startAt).format("jYYYY/jMM/jDD")}
                    {startAt &&
                      effectiveStartAt &&
                      moment(startAt).isBefore(
                        moment(effectiveStartAt).startOf("day")
                      ) && (
                        <span style={{ fontSize: "11px", color: "#888" }}>
                          {" "}
                          (انتخابی: {moment(startAt).format("jYYYY/jMM/jDD")})
                        </span>
                      )}
                  </p>
                  {expectedEndAt && (
                    <p style={{ margin: "4px 0" }}>
                      تاریخ پایان: {moment(expectedEndAt).format("jYYYY/jMM/jDD")}
                    </p>
                  )}
                </>
              )}
            </div>
          </div>

          {/* BODY */}
          <div
            className="invoiceBody"
            style={{
              margin: "20px 0",
              fontSize: "12px",
            }}
          >
            <div className="invoiceItems">
              <table
                id="invoiceTable"
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                  marginBottom: 10,
                }}
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: 6,
                        textAlign: "center",
                        backgroundColor: "#04AA6D",
                        color: "white",
                        WebkitPrintColorAdjust: "exact", // اجبار مرورگر به چاپ رنگ پس‌زمینه
                        printColorAdjust: "exact", // اجبار مرورگر به چاپ رنگ پس‌زمینه
                      }}
                    >
                      محصول
                    </th>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: 6,
                        textAlign: "center",
                        backgroundColor: "#04AA6D",
                        color: "white",
                        WebkitPrintColorAdjust: "exact", 
                        printColorAdjust: "exact",
                      }}
                    >
                      مبلغ (ریال)
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    style={{
                      backgroundColor: "#f2f2f2",
                      textAlign: "right",
                      WebkitPrintColorAdjust: "exact",
                      printColorAdjust: "exact",
                    }}
                  >
                    <td style={{ border: "1px solid #ddd", padding: 6 }}>
                      {invoiceType === "CARD_REQUEST"
                        ? "کارت عضویت صفاتک"
                        : invoiceType === "HOLIDAY"
                        ? "استفاده از خدمات صفاتک در روزهای تعطیل"
                        : "محصول"}
                    </td>

                    <td style={{ border: "1px solid #ddd", padding: 6, textAlign: "left" }}>
                      {amountRial?.toLocaleString()}
                    </td>
                  </tr>
                </tbody>
              </table>

              {/* DISCOUNT */}
              {discountAmount !== 0 && (
                <>
                  <Row style={{ padding: "0 10px" }}>
                    <Col span={18} style={{ textAlign: "right" }}>تخفیف: </Col>
                    <Col span={6} style={{ textAlign: "left" }}>
                      {discountAmount?.toLocaleString()}
                    </Col>
                  </Row>

                  <Row
                    style={{
                      padding: "5px 10px",
                      margin: "10px 0",
                      background: "rgba(0, 0, 255, 0.2)",
                      WebkitPrintColorAdjust: "exact", // برای چاپ شدن رنگ ردیف مبلغ نهایی
                      printColorAdjust: "exact",
                    }}
                  >
                    <Col span={18} style={{ fontWeight: "bold", textAlign: "right" }}>
                      مبلغ قابل پرداخت:
                    </Col>
                    <Col span={6} style={{ textAlign: "left" }}>
                      {finalAmount?.toLocaleString()}
                    </Col>
                  </Row>
                </>
              )}

              {/* DESCRIPTION */}
              {description && (
                <div className="invoiceDescription" style={{ marginTop: 20, textAlign: "right" }}>
                  <h4 style={{ fontWeight: "bold", marginBottom: 5 }}>توضیحات:</h4>
                  <p style={{ margin: 0 }}>{description}</p>
                </div>
              )}

              {(effectiveStartAt || startAt) && (
                <div
                  style={{
                    marginTop: 15,
                    padding: "8px 12px",
                    background: "#f9f9f9",
                    borderRadius: 6,
                    fontSize: "12px",
                    textAlign: "right",
                  }}
                >
                  <div>
                    <strong>تاریخ شروع دوره: </strong>
                    {moment(effectiveStartAt || startAt).format("jYYYY/jMM/jDD")}
                    {startAt &&
                      effectiveStartAt &&
                      moment(startAt).isBefore(
                        moment(effectiveStartAt).startOf("day")
                      ) && (
                        <span style={{ color: "#d48806" }}>
                          {" "}
                          (تاریخ اولیه انتخابی: {moment(startAt).format("jYYYY/jMM/jDD")})
                        </span>
                      )}
                  </div>
                  {expectedEndAt && (
                    <div style={{ marginTop: 4 }}>
                      <strong>تاریخ پایان پیش‌بینی‌شده: </strong>
                      {moment(expectedEndAt).format("jYYYY/jMM/jDD")}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* FOOTER */}
          <div
            className="invoiceFooter"
            style={{
              borderTop: "1px solid #3a4e61",
              textAlign: "left",
              position: "absolute",
              bottom: 10,
              left: 15,
              right: 15,
              paddingTop: 5,
              fontSize: "11px",
            }}
          >
            <p style={{ margin: 0 }}>invoice id: {id}</p>
          </div>
        </div>
      </div>
    </div>
  );
});

export default Invoice;
